import { wrapGql } from "../_"

export default (a: NuxtAxiosInstance) => ({
  listPhotoEvent: (page?: number) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query ($page: Int) {
          listPhotoEvent (
            page: $page
            sorters: [{ name: "position" order: ASC }]
            limit: 12
          ) {
            items {
              id
              event {
                alias
                title {
                  current
                }
                banner {
                  url
                }
                bannerEn {
                  url
                }
              }
              position
              date
              cover {
                url
              }
              photosCount
              groupsCount
            }
            pagination {
              pages
            }
          }
        }
      `,
      variables: {
        page,
      },
    }),
  ),

  listPhotoGroup: (filters?: any, page?: number, cfg?: AxiosConfig) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query ($filters: [Filter] $page: Int) {
          listPhotoGroup (
            page: $page
            filters: $filters
            sorters: [{ name: "position" order: ASC }]
            limit: 12
          ) {
            items {
              id
              photoEvent {
                event {
                  alias
                  title {
                    current
                  }
                }
              }
              position
              title {
                current
              }
              date
              cover {
                url
              }
              photosCount
              tags {
                id
              }
            }
            pagination {
              pages
            }
          }
        }
      `,
      variables: {
        filters,
        page,
      },
    }, cfg),
  ),

  listPhoto: (filters?: any, page?: number, cfg?: AxiosConfig) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query ($filters: [Filter] $page: Int) {
          listPhoto (
            page: $page
            filters: $filters
            sorters: [{ name: "position" order: ASC }]
            limit: 999
          ) {
            items {
              id
              file {
                url
              }
              thumbnail {
                url
              }
              author {
                current
              }
              group {
                id
                title {
                  current
                }
                photoEvent {
                  event {
                    alias
                    title {
                      current
                    }
                  }
                }
              }
              position
            }
            pagination {
              pages
            }
          }
        }
      `,
      variables: {
        filters,
        page,
      },
    }, cfg),
  ),
})
